import Moment from 'moment';
import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Button, FormControl, InputLabel, Select, MenuItem, Hidden } from "@material-ui/core";
import { useSelector, useDispatch } from 'react-redux';
import ErrorHandling from '../ErrorHandling/ErrorHandling';
import { genfunction } from '../../helpers';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Typography from '@material-ui/core/Typography';
import ExtraItemDrawer from 'components/CalendarControls/ExtraItemDrawer';
import Drawer from '@material-ui/core/Drawer';
import { actionGetExtraItems, actionResetExtraItems } from 'actions';
import { withRouter } from 'react-router';
import { actionShopCartSetManageMyBooking } from 'actions';
import { actionResetBooking } from 'actions';
import * as underscore from 'underscore'
import ReactHtmlParser from 'react-html-parser';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import StaticDatePicker from '@mui/lab/StaticDatePicker';
import TextField from '@mui/material/TextField';
import Badge from '@mui/material/Badge';
import PickersDay from '@mui/lab/PickersDay';
import GroupReservationDrawer from './GroupReservationDrawer';
import ArrowDropDownCircleSharpIcon from '@material-ui/icons/ArrowDropDownCircleSharp';

const { DefaultCostRateID, CalendarScreenMessage1, CalendarScreenMessage2, HybridViewDefaultLargeImage, HybridViewDefaultSmallImage,
    Currency, NoEventMessage, HybridViewDropDownLabel } = window['runConfig'];
const useStyles = makeStyles(theme => ({
    root: {
        justifyContent: "center"
    },
    list: {
        width: 400,
        fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"'
    }
    ,
    list2: {
        width: '100%',
        fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"'
    },
    image: {
        width: "100%",
        objectFit: "cover",
        objectPosition: "center"
    },
    CardHeader: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
    TimeSlotSelect: {
        marginLeft: 8,
        marginRight: 8
    },
    badgeDot: {
        [theme.breakpoints.up('md')]: {
            right: "25% !important"
        }
    },
    staticcal: {
        width: "100% !important",
    },
    hidden: {
        visibility: "hidden"
    },
    visible: {
        visibility: "visible"
    },
    largeImg: {
        [theme.breakpoints.down('sm')]: {
            display: 'none !important',
        },
    },
    '@global': {
        '.MuiPickerStaticWrapper-root': {
            width: "100% !important",
            minWidth: "100% !important"
        },
        '.css-epd502': {
            width: "100% !important"
        },
        '.MuiCalendarPicker-root': {
            width: "100% !important"
        },
        '.css-1n2mv2k': {
            display: "flex  !important",
            flexDirection: "row  !important"
        },
        '.css-mvmu1r': {
            paddingTop: "5px !important",
            // paddingBottom: "5px !important",
            display: "flex  !important",
            flexDirection: "row  !important"
        },
        '.css-1n2mv2k span': {
            flexGrow: "1  !important",
            width: "auto  !important",
            [theme.breakpoints.up('md')]: {
                fontSize: "1.2rem !important"
            }
        },
        '.Badge_Price': {
            flexGrow: "1  !important",
            justifyContent: "center !important"
        },
        '.MuiPickersDay-root': {
            [theme.breakpoints.up('md')]: {
                fontSize: "1.2rem !important"
            }
        },
        '.MuiPickersDay-dayOutsideMonth': {
            [theme.breakpoints.down('xs')]: {
                width: "20px !important",
            }
        },
        '.MuiPickersDay-dayWithMargin': {
            [theme.breakpoints.down('xs')]: {
                width: "20px !important",
            }
        }
    }
}));

const CalendarHybridView = (props) => {

    const classes = useStyles();
    const dispatch = useDispatch();

    const [state, setState] = React.useState({
        right: false,
        tourEventId: 0,
        bookingTypeID: 0,
        errorMsg: '',
        TourEventTimeSlot: [],
        selectedDate: undefined,
        isContinueToExtraItemDrawer: false,
        isContinueToGroupDrawer: false,
        organizationID: "",
        groupSize: "",
        isEditEvent: false
    });

    let tourEvents = useSelector(state => state.reducerExtraItems.extramItems);
    const errExtraItem = useSelector(state => state.reducerExtraItems.extramItemsError);
    const displayAreasState = useSelector(state => state.reducerDisplayAreas);
    const bookingTypes = useSelector(state => state.reducerBookingTypes);
    const shopcartreducer = useSelector(state => state.reducerShopCart);
    const reducerBooking = useSelector(state => state.reducerBooking);

    useEffect(() => {

        let propsEvent = props.location.event;
        if (props.Path == "/calendar/:id") {

            propsEvent && Moment(propsEvent.EventDate).format('YYYY-MM') !== Moment(bookingTypes.bookingType.NextTourDate).format('YYYY-MM') ?
                actionGetExtraItems(dispatch, props.urlID, false, false, propsEvent.EventDate, false, null)
                :
                actionGetExtraItems(dispatch, props.urlID, true, false, bookingTypes.bookingType.NextTourDate, false, null);

        }
        else {

            if (displayAreasState.displayAreas !== undefined && displayAreasState.displayAreas.length > 0) {
                let displayarea = displayAreasState.displayAreas.find(x => x.DisplayAreaNo == props.urlID);

                propsEvent && Moment(propsEvent.EventDate).format('YYYY-MM') !== Moment(displayarea.NextTourDate).format('YYYY-MM') ?
                    actionGetExtraItems(dispatch, props.urlID, false, true, propsEvent.EventDate, false, null)
                    :
                    actionGetExtraItems(dispatch, props.urlID, true, true, displayarea.NextTourDate, false, null);
            }
            else {

                propsEvent && Moment(propsEvent.EventDate).format('YYYY-MM') !== Moment(displayAreasState.displayArea.NextTourDate).format('YYYY-MM') ?
                    actionGetExtraItems(dispatch, props.urlID, false, true, propsEvent.EventDate, false, null)
                    :
                    actionGetExtraItems(dispatch, props.urlID, true, true, displayAreasState.displayArea.NextTourDate, false, null);
            }
        }
    }, []);

    useEffect(() => {
        if (state.selectedDate && tourEvents && tourEvents.length > 0) {
            let BookingInfoFilter = underscore.filter(tourEvents, (item) => {
                return item.BookNowOption !== "Past Event" && item.BookNowOption !== "Cancelled"
                    && item.BookingInfo && item.BookingInfo.length > 0
                    && item.EventDate == Moment(state.selectedDate).format('YYYY-MM-DD')
            });

            let BookingInfoGroup = underscore.groupBy(BookingInfoFilter, (tourEvent) => { return tourEvent.BookingInfo });

            if (BookingInfoGroup && Object.keys(BookingInfoGroup).length == 1 && BookingInfoGroup[Object.keys(BookingInfoGroup)[0]].length > 0) {
                setState({ ...state, TourEventTimeSlot: BookingInfoFilter });
            }


        }

    }, [state.selectedDate, tourEvents]);

    useEffect(() => {
        getFirstEventDate();
    }, [bookingTypes, tourEvents]);

    const hideSelectButtonOnSingleBooking = () => {
        if (state.selectedDate && tourEvents && tourEvents.length > 0) {
            let BookingInfoFilter = underscore.filter(tourEvents, (item) => {
                return item.BookNowOption !== "Past Event" && item.BookNowOption !== "Cancelled"
                    && item.BookingInfo && item.BookingInfo.length > 0
                    && item.EventDate == Moment(state.selectedDate).format('YYYY-MM-DD')
            });

            let BookingInfoGroup = underscore.groupBy(BookingInfoFilter, (tourEvent) => { return tourEvent.BookingInfo });

            if (BookingInfoGroup && Object.keys(BookingInfoGroup).length == 1)
                return true;
        }

    }

    const toggleDrawer = (side, open, event) => {
        if (event)
            setState({ ...state, [side]: open, tourEventId: event.TourEventID, bookingTypeID: event.BookingTypeID });
        else {

            props.location.event = null;
            setState({ ...state, [side]: open, tourEventId: 0, groupSize: "", organizationID: "", isContinueToExtraItemDrawer: false, isContinueToGroupDrawer: false, isEditEvent: false });
        }
    };

    const checkIsReloadEvent = (event) => {

        let reloadEvent = false;

        if (genfunction.IsEditEvent(bookingTypes.bookingTypes, event)) {

            if (shopcartreducer.events && shopcartreducer.events.length > 0 && shopcartreducer.events.find(x => x.TourEventID == event.TourEventID)) {
                reloadEvent = true;
                event = shopcartreducer.events.filter(x => x.TourEventID == event.TourEventID)[0];
            }

            reloadEvent ? reloadEventForGroups(event) : toggleDrawer('right', true, event);

        }
        else {
            toggleDrawer('right', true, event);
        }
    }

    const reloadEventForGroups = (event) => {

        if (event && event.hasOwnProperty("TourEventID")) {

            setState({
                ...state,
                right: true,
                tourEventId: event.TourEventID,
                bookingTypeID: event.BookingTypeID,
                selectedDate: new Date(event.EventDate),
                groupSize: event.GroupSize,
                organizationID: event.OrganizationID,
                isContinueToGroupDrawer: event.OrganizationID !== "" ? true : false,
                isEditEvent: true
            });
        }

    }

    const setIsEditEvent = (value) => {
        setState({
            ...state, isEditEvent: value
        });
    }

    const goToExtraItemOrGroupDrawer = (value) => {
        setState({ ...state, isContinueToExtraItemDrawer: value, isContinueToGroupDrawer: !value });
    }

    const showGroupDrawer = () => {

        const bType = bookingTypes.bookingTypes.filter(x => x.BookingTypeID == state.bookingTypeID)[0];

        if (bType && !state.isContinueToExtraItemDrawer) {
            if (bType.RequireCompanyName || bType.ShowTourProductsBasedOnGroupSize || state.isContinueToGroupDrawer)
                return true;
        }

        return false
    }
    const onChangeOrganization = (value) => {

        value ? setState({ ...state, organizationID: value.CustomerID }) : setState({ ...state, organizationID: "" })
    }

    const onChangeGroupSize = (value) => {

        value ? setState({ ...state, groupSize: value.GroupSize }) : setState({ ...state, groupSize: "" })

    }

    const sideList = side => {

        return (
            < div className={window.matchMedia("(min-width: 600px)").matches ? classes.list : classes.list2} role="presentation" >

                {showGroupDrawer() ?

                    <GroupReservationDrawer goToExtraItemOrGroupDrawer={goToExtraItemOrGroupDrawer}
                        ismembershipapplied={shopcartreducer.membershipValidation.ismembershipApplied}
                        membercostrate={shopcartreducer.membershipValidation.membershipcostrate}
                        isIDME={shopcartreducer.IDME.isIdMeApplied}
                        isIDMECostrate={shopcartreducer.IDME.idmecostrate}
                        organizationID={state.organizationID} groupSize={state.groupSize}
                        onChangeOrganization={onChangeOrganization}
                        onChangeGroupSize={onChangeGroupSize}
                        bookingtypeID={state.bookingTypeID} tourEventId={state.tourEventId} toggleDrawer={toggleDrawer}
                        isEditEvent={state.isEditEvent} toggleIsEdit={setIsEditEvent} isContinueToGroupDrawer={state.isContinueToGroupDrawer}
                    />
                    :
                    <ExtraItemDrawer tourEventId={state.tourEventId}
                        ismembershipapplied={shopcartreducer.membershipValidation.ismembershipApplied}
                        membercostrate={shopcartreducer.membershipValidation.membershipcostrate}
                        isIDME={shopcartreducer.IDME.isIdMeApplied}
                        isIDMECostrate={shopcartreducer.IDME.idmecostrate}
                        bookingtypeID={state.bookingTypeID} callCheckout={constredirect}
                        toggleDrawer={toggleDrawer} isEditEvent={state.isEditEvent}
                        groupSize={state.groupSize} organizationID={state.organizationID}
                        goToExtraItemOrGroupDrawer={goToExtraItemOrGroupDrawer} isContinueToExtraItemDrawer={state.isContinueToExtraItemDrawer}
                    />

                }
            </div >)
    };

    const constredirect = (products) => {
        setState({ ...state, selectedDate: undefined });
        props.constredirect(products);
    }

    const errorcancelhandle = () => {
        actionResetExtraItems(dispatch);
        setState({ ...state, right: false, errorMsg: '' });
    }

    const GetBookingInfoLargeImageURL = () => {
        if (props.Path == "/calendar/:id") {
            return bookingTypes.bookingType ? genfunction.replaceEscapeCharacters(bookingTypes.bookingType.LargeImageURL) : "";
        }
        else if (props.Path == "/calendar/Area/:id") {
            return displayAreasState.displayArea ? genfunction.replaceEscapeCharacters(displayAreasState.displayArea.LargeImageURL) : "";
        }
        return "";
    }

    const GetBookingInfoBookingInfoDetails = () => {
        if (props.Path == "/calendar/:id") {
            let bookingInfoDetails = '';

            if (bookingTypes.bookingTypes && bookingTypes.bookingTypes.length > 0 && bookingTypes.bookingTypes.filter(x => x.BookingTypeID === parseInt(props.urlID).length > 0)) {
                return bookingInfoDetails = bookingTypes.bookingTypes.filter(x => x.BookingTypeID === parseInt(props.urlID))[0].BookingInfoDetails;
            }
        }
        else if (props.Path == "/calendar/Area/:id") {
            return displayAreasState.displayArea ? displayAreasState.displayArea.BookingInfoDetails : " ";
        }
        return "";
    }

    const GetTourEventsGroup = () => {

        let BookingInfoFilter = underscore.filter(tourEvents, (item) => {
            return item.BookNowOption !== "Past Event" && item.BookNowOption !== "Cancelled"
                && item.BookingInfo && item.BookingInfo.length > 0
                && item.EventDate == Moment(state.selectedDate).format('YYYY-MM-DD')
        });

        let BookingInfoGroup = underscore.groupBy(BookingInfoFilter, (tourEvent) => { return tourEvent.BookingInfo });
        return BookingInfoGroup;
    }

    const GetFilterDates = (date) => {
        actionGetExtraItems(dispatch, props.urlID, true, displayAreasState.isDisplay ? true : false, date);
    }

    const GetDefaultCostRate = (PriceMatrix) => {
        let pamtrix = undefined;
        let costrate = shopcartreducer.ismembershipApplied ? shopcartreducer.membershipcostrate : DefaultCostRateID;

        if (PriceMatrix.length > 1) {
            pamtrix = PriceMatrix.find(x => x.CostRateID == costrate);
        }
        else {
            pamtrix = PriceMatrix && PriceMatrix.length > 0 ? PriceMatrix[0] : undefined;
        }

        return pamtrix;
    }

    const redirecttoconfirmbookingchanges = (event) => {

        if (shopcartreducer.managemybooking && reducerBooking.booking[0]) {

            if (reducerBooking.booking[0].TourEventID !== event.TourEventID) {
                props.history.push({
                    pathname: '/confimbookingchanges',
                    eventID: event.TourEventID,
                    ismembershipapplied: shopcartreducer.membershipValidation.membershipcostrate,
                    membercostrate: shopcartreducer.membershipValidation.membershipcostrate,
                    bookingtypeID: event.BookingTypeID

                })
            }
        }
    }

    const constredirecttofindmybpooking = () => {
        actionResetBooking(dispatch);
        actionShopCartSetManageMyBooking(dispatch, false, false);

        props.history.push({
            pathname: '/findmybooking'
        })

    }

    const GetBookingInfoText = (BookingInfoText) => {
        return BookingInfoText;
    }

    const BookingInfoClickHandler = (BookingInfo) => {

        let BookingInfoFilter = underscore.filter(tourEvents, (item) => {
            return item.BookingInfo == BookingInfo
                && item.BookNowOption !== "Past Event" && item.BookNowOption !== "Cancelled"
                && item.EventDate == Moment(state.selectedDate).format('YYYY-MM-DD')
        });

        // if (BookingInfoFilter && BookingInfoFilter.length == 1) {
        //     if (shopcartreducer.managemybooking)
        //         redirecttoconfirmbookingchanges(getTourEvent(BookingInfoFilter[0].TourEventID))
        //     else
        //         toggleDrawer('right', true, getTourEvent(BookingInfoFilter[0].TourEventID))
        // }
        // else
        setState({ ...state, TourEventTimeSlot: BookingInfoFilter });
    }

    const StartAndEndTime = (tourEvent, bookingTypeID) => {
        let time = "";
        let bookType = bookingTypes.bookingTypes.find(x => x.BookingTypeID == bookingTypeID);

        if (bookType) {
            if (bookType.ShowStartTime) {
                time += Moment(tourEvent.EventStartDateTime).format('hh:mm a');
            }

            if (bookType.ShowEndTime && !bookType.ShowStartTime) {
                time += Moment(tourEvent.EventEndDateTime).format('hh:mm a')
            }

            if (bookType.ShowEndTime && bookType.ShowStartTime) {
                time += ' - ' + Moment(tourEvent.EventEndDateTime).format('hh:mm a')
            }

            time += ' ';
        }
        return time;
    }

    const GetWebDisplayName = (tourEvent, bookingTypeID) => {
        let bookType = bookingTypes.bookingTypes.find(x => x.BookingTypeID == bookingTypeID);
        return bookType ? tourEvent.EventName : '';
    }

    const GetAvailabilityText = (tourEvent, bookingTypeID) => {
        let bookType = bookingTypes.bookingTypes.find(x => x.BookingTypeID == bookingTypeID);

        if (tourEvent.BookNowOption === 'Book Now' && bookType != undefined && bookType.ShowAvailability)
            return ' (' + tourEvent.SeatsAvailable + ' ' + bookType.AvailabilityText + ')';
        else
            return ' (' + tourEvent.BookNowOption + ')';
    }

    const IsEventAvailableToSale = (event) => {
        if (event.BookNowOption != 'Book Now') {
            return false;
        }
        else return true;
    }

    const showTourList = (BookingInfo) => {
        if (state.TourEventTimeSlot == undefined || state.TourEventTimeSlot.length == 0)
            return false;
        else
            return state.TourEventTimeSlot.find(item => item.BookingInfo == BookingInfo);
    }

    const getTourEvent = (TourEventID) => {
        return tourEvents.find(x => x.TourEventID == TourEventID);
    }

    const getFirstEventDate = () => {
        if (state.selectedDate == undefined) {
            if (props.match.path == "/calendar/:id" && bookingTypes && bookingTypes.bookingTypes && bookingTypes.bookingTypes.length > 0) {
                let bookingType = bookingTypes.bookingTypes.find(x => x.BookingTypeID == props.urlID && x.NextTourDate && x.NextTourDate.length > 0);
                if (bookingType) {
                    setState({ ...state, selectedDate: new Date(Moment(bookingType.NextTourDate)) });
                }
                else {
                    setState({ ...state, selectedDate: new Date(Moment()) });
                }
            }
            else if (props.match.path == "/calendar/Area/:id") {
                let btypes = bookingTypes.bookingTypes.filter(x => x.NextTourDate && x.NextTourDate.length > 0);
                if (btypes && btypes.length > 0) {
                    setState({ ...state, selectedDate: new Date(Moment(btypes.NextTourDate)) });
                }
                else if (tourEvents && tourEvents != "nocontent") {
                    let tourevent = tourEvents.find(event => { return event.BookingInfo && event.BookingInfo.length > 0 && event.BookNowOption !== "Past Event" && event.BookNowOption !== "Cancelled" });
                    if (tourevent)
                        setState({ ...state, selectedDate: new Date(Moment(tourevent.EventDate)) });
                }
            }
        }
        else {
            if (tourEvents && tourEvents != "nocontent" && tourEvents.length > 0) {
                let tourevent = tourEvents.find(event => {
                    return event.EventDate >= Moment(new Date()).format('YYYY-MM-DD') && event.BookNowOption !== "Past Event" && event.BookNowOption !== "Cancelled"

                });

                if (tourevent)
                    setState({ ...state, selectedDate: new Date(Moment(tourevent.EventDate)), TourEventTimeSlot: [] });
                else {
                    setState({ ...state, selectedDate: new Date() });
                }
            }
        }

        reloadEventForGroups(props.location.event);

    }

    const hasEvent = (date) => {
        if (tourEvents && tourEvents != "nocontent" && tourEvents.length > 0 && date) {
            let tourevent = tourEvents.find(event => { return event.BookingInfo && event.BookingInfo.length > 0 && event.BookNowOption !== "Past Event" && event.BookNowOption !== "Cancelled" && event.EventDate == Moment(date).format('YYYY-MM-DD') });
            return tourevent;
        }
    }

    const getEventPrice = (date) => {
        if (tourEvents && tourEvents != "nocontent") {
            let tourevent = tourEvents.find(event => { return event.BookingInfo && event.BookingInfo.length > 0 && event.BookNowOption !== "Past Event" && event.BookNowOption !== "Cancelled" && event.EventDate == Moment(date).format('YYYY-MM-DD') });
            if (tourevent && tourevent.TourProducts && tourevent.TourProducts.length > 0) {
                let product = tourevent.TourProducts.find(x => x.ShowOnCalendar && x.AffectsCapacity && x.PriceMatrix);
                if (product) {
                    let PriceMatrix = GetDefaultCostRate(product.PriceMatrix);
                    if (PriceMatrix) {
                        return Currency + PriceMatrix.Price
                    }
                }
            }
        }
        return undefined;
    }

    const hasMultipleBookingType = () => {
        let BookingTypeGroup = underscore.groupBy(bookingTypes.bookingTypes, (bookingType) => { return bookingType.BookingTypeID });
        if (BookingTypeGroup && Object.keys(BookingTypeGroup).length > 1)
            return true;
        else
            return false;
    }

    const StaticCalenderView = () => {
        return (<Card className={classes.card}>
            <CardContent>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <StaticDatePicker
                        displayStaticWrapperAs="desktop"
                        disablePast={true}
                        views={['day']}
                        openTo="day"
                        value={state.selectedDate}
                        showDaysOutsideCurrentMonth={false}
                        onChange={(newValue) => {
                            setState({ ...state, selectedDate: newValue, TourEventTimeSlot: [], isEditEvent: false });

                        }}

                        onMonthChange={(day) => {
                            //setState({ ...state, selectedDate: day, TourEventTimeSlot: [] });
                            setState({ ...state, selectedDate: new Date(Moment(day)), TourEventTimeSlot: [], isEditEvent: false });
                            if (tourEvents.length == 0 || Moment(state.selectedDate).format('YYYY-MM') !== Moment(day).format('YYYY-MM')) {
                                let newdate = Moment(day).format('YYYY-MM-DD');
                                GetFilterDates(newdate);
                            }
                        }}
                        renderDay={(day, _value, DayComponentProps) => {

                            const isSelected = hasEvent(day);

                            return (
                                <Badge key={day.toString()}
                                    badgeContent={getEventPrice(day)} color="success"
                                    variant={hasMultipleBookingType() ? "dot" : "standard"}
                                    overlap="circular" invisible={!isSelected}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'right'
                                    }}
                                    className={"Badge_Price"}
                                    classes={{ anchorOriginBottomRight: classes.badgeDot }}
                                >
                                    <PickersDay {...DayComponentProps} />
                                </Badge>
                            );
                        }}
                        renderInput={(params) => <TextField {...params} />}
                    />
                </LocalizationProvider>
            </CardContent>
        </Card>)
    }

    return (
        <Grid id="vt_component_tour_hybridview" className={classes.root} container spacing={2}>

            <ErrorHandling msg={errExtraItem.length > 0 ? errExtraItem : state.errorMsg}
                open={errExtraItem.length > 0 || state.errorMsg != "" ? true : false}
                handleclose={errorcancelhandle} />

            {shopcartreducer.managemybooking && reducerBooking.booking[0] && reducerBooking.booking[0].hasOwnProperty('AllowDateTimeChanges') && !reducerBooking.booking[0].AllowDateTimeChanges ?
                <>
                    <Grid item align="center" xs={12} ms={12} lg={12}>

                        <Typography variant="h4" style={{ padding: "10px" }} >
                            {reducerBooking.booking[0].hasOwnProperty('NoChangesMessage') ? reducerBooking.booking[0].NoChangesMessage : 'Date Time Changes are not allowed.'}
                        </Typography>
                        <Button variant="outlined" size="medium" color="primary"
                            style={{ padding: "10px" }}
                            onClick={() => constredirecttofindmybpooking()}>
                            Cancel Changes
                        </Button>
                    </Grid>
                </>
                :
                <>
                    {shopcartreducer.managemybooking ?
                        <Grid item align="center" xs={12} ms={12} lg={12}>

                            <Typography variant="h4" style={{ padding: "10px" }} >
                                {CalendarScreenMessage1} {Moment(reducerBooking.booking[0].EventStartDateTime).format('dddd,MMMM D')} at  {Moment(reducerBooking.booking[0].EventStartDateTime).format('LT')} {CalendarScreenMessage2}
                            </Typography>
                            <Button variant="outlined" size="medium" color="primary"
                                style={{ padding: "10px" }}
                                onClick={() => constredirecttofindmybpooking()}>
                                Cancel Changes
                            </Button>
                        </Grid> : null}

                    <Grid item xs={12} md={4}>
                        <img className={classes.image + ' ' + classes.largeImg} alt="LargeImage" src={GetBookingInfoLargeImageURL() != "" ? GetBookingInfoLargeImageURL() : genfunction.replaceEscapeCharacters(HybridViewDefaultLargeImage)} />
                    </Grid>
                    <Hidden mdUp>
                        <Grid item xs={12}>
                            <StaticCalenderView></StaticCalenderView>
                        </Grid>
                    </Hidden >

                    <Grid item xs={12} md={4}>
                        <Grid container spacing={1}>
                            {hasEvent(state.selectedDate) ?
                                underscore.map(GetTourEventsGroup(), (items, key) => {
                                    return (
                                        <Grid item key={key} xs={12}>
                                            <Grid item xs={12}>
                                                <Card className={classes.card}>
                                                    <CardHeader className={classes.CardHeader}
                                                        title={items[0].BookingInfo}
                                                        titleTypographyProps={{ color: "inherit" }}
                                                    />
                                                    <CardContent>
                                                        <Grid container spacing={1}>
                                                            <Grid item xs={12} sm={6}>
                                                                <img className={classes.image} alt="LargeImage" src={items[0].SmallImageURL != "" ? genfunction.replaceEscapeCharacters(items[0].SmallImageURL) : genfunction.replaceEscapeCharacters(HybridViewDefaultSmallImage)} />
                                                            </Grid>
                                                            <Grid item xs={12} sm={6}>
                                                                <Typography component="p" color="textSecondary">
                                                                    {GetBookingInfoText(genfunction.replaceEscapeCharacters(items[0].BookingInfoText))}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={12} sm={6}>
                                                                <Button variant="contained" fullWidth={true}
                                                                    className={hideSelectButtonOnSingleBooking() ? classes.hidden : classes.visible} disabled={showTourList(items[0].BookingInfo) ? true : false}
                                                                    color="primary"
                                                                    onClick={() => { BookingInfoClickHandler(items[0].BookingInfo) }}>Select</Button>
                                                            </Grid>
                                                        </Grid>
                                                    </CardContent>

                                                    {showTourList(items[0].BookingInfo) ?
                                                        <CardActions>
                                                            <FormControl className={classes.TimeSlotSelect} fullWidth >
                                                                <InputLabel shrink id={key + "TimeSlotLable"} className={"SelectResourceDropDownHeading"}>
                                                                    {HybridViewDropDownLabel}
                                                                </InputLabel>
                                                                <Select
                                                                    labelId={key + "TimeSlotLable"}
                                                                    id={key + "TimeSlotSelect"}
                                                                    value={state.tourEventId}
                                                                    onChange={(event) => {
                                                                        shopcartreducer.managemybooking ?
                                                                            redirecttoconfirmbookingchanges(getTourEvent(event.target.value))
                                                                            :
                                                                            checkIsReloadEvent(getTourEvent(event.target.value), 'right', true)
                                                                    }}
                                                                    IconComponent={() => <ArrowDropDownCircleSharpIcon color="primary" fontSize='large' />}
                                                                >
                                                                    {
                                                                        state.TourEventTimeSlot.map((event) => {
                                                                            return (<MenuItem disabled={!IsEventAvailableToSale(event)} key={event.TourEventID} value={event.TourEventID}>{StartAndEndTime(event, event.BookingTypeID) + GetWebDisplayName(event, event.BookingTypeID) + GetAvailabilityText(event, event.BookingTypeID)}</MenuItem>)
                                                                        })
                                                                    }
                                                                </Select>
                                                            </FormControl>
                                                        </CardActions>
                                                        : ""}
                                                </Card>
                                            </Grid>
                                        </Grid>
                                    )
                                })
                                : <Grid item xs={12} alignContent="center" justifyContent="center" align="center"><Typography variant="h3" >{Moment(state.selectedDate).format('DD-MMM-YYYY')}</Typography><Typography variant="h3" >{NoEventMessage}</Typography></Grid>}

                        </Grid>
                    </Grid>
                    <Grid container item xs={12} md={4} spacing={2} alignContent='flex-start'>
                        <Hidden smDown>
                            <Grid item xs={12}>
                                <StaticCalenderView></StaticCalenderView>
                            </Grid>
                        </Hidden >

                        <Grid item xs={12}>
                            {ReactHtmlParser(genfunction.replaceEscapeCharacters(GetBookingInfoBookingInfoDetails() ? GetBookingInfoBookingInfoDetails() : ""))}
                        </Grid>
                    </Grid>

                    <div>
                        <Drawer anchor="right" open={state.right} onClose={() => toggleDrawer('right', false)}>
                            {sideList('right')}
                        </Drawer>
                    </div>
                </>}
        </Grid >
    );
}
export default withRouter(CalendarHybridView);
